





/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// GETALLAPPROVEDCUSTOMERSWITHCREATORANDAPPROVER
// GETALLAPPROVEDCUSTOMERSWITHCREATORANDAPPROVER


const GETALLAPPROVEDCUSTOMERSWITHCREATORANDAPPROVER= createAsyncThunk(
  "getAllApprovedCustomersWithCreatorAndApprover/getAllApprovedCustomersWithCreatorAndApprover",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllApprovedCustomersWithCreatorAndApproverSlice = createSlice({
  name: "getAllApprovedCustomersWithCreatorAndApproverSlice",
  initialState: {
    getAllApprovedCustomersWithCreatorAndApprover: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAllApprovedCustomersWithCreatorAndApprover: (state) => {
        state.getAllApprovedCustomersWithCreatorAndApprover.loading = false
        state.getAllApprovedCustomersWithCreatorAndApprover.error = false
        state.getAllApprovedCustomersWithCreatorAndApprover.data = []
        state.getAllApprovedCustomersWithCreatorAndApprover.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETALLAPPROVEDCUSTOMERSWITHCREATORANDAPPROVER.fulfilled, (state, action) => {
      state.getAllApprovedCustomersWithCreatorAndApprover = {
        ...state.getAllApprovedCustomersWithCreatorAndApprover,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLAPPROVEDCUSTOMERSWITHCREATORANDAPPROVER.pending, (state, action) => {
      state.getAllApprovedCustomersWithCreatorAndApprover = {
        ...state.getAllApprovedCustomersWithCreatorAndApprover,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLAPPROVEDCUSTOMERSWITHCREATORANDAPPROVER.rejected, (state, action) => {
      state.getAllApprovedCustomersWithCreatorAndApprover = {
        ...state.getAllApprovedCustomersWithCreatorAndApprover,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllApprovedCustomersWithCreatorAndApproverAction = {
    GETALLAPPROVEDCUSTOMERSWITHCREATORANDAPPROVER,
};

export { getAllApprovedCustomersWithCreatorAndApproverAction };
export default getAllApprovedCustomersWithCreatorAndApproverSlice.reducer;
export const {setInitialStateOfgetAllApprovedCustomersWithCreatorAndApprover} = getAllApprovedCustomersWithCreatorAndApproverSlice.actions
